import React, { useState } from "react";
import {
  MotifIcon,
  MotifToast,
  MotifFileUploaderItem,
  MotifFileUploader,
  MotifLabel,
  MotifButton,
  MotifFormField,
  MotifProgressIndicator,
  MotifProgressIndicatorStep,
  MotifInput
} from "@ey-xd/motif-react";
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { MotifProgressLoader } from "@ey-xd/motif-react";
import { apiQueryToUploadDataRegional } from "../../common/services/apiBaseUrlConfig";
import { getAccount } from "../../common/services/commonService";
import { useLocation } from 'react-router-dom';
import { checkIcon } from '../../common/MotifIcons';
import JSZip from "jszip";
import { AMERICAS, APAC, EMEIA, UNITED_KINGDOM } from "../../common/contants/constants";

import "./uploadPartnerData.scss";
import logger from "../../common/utils/logger";
import { beginLongRunningTask } from "../../common/services/activityMonitor";

export const UploadPartnerData = () => {
  const location = useLocation();
  const rowData = location.state;
  const navigate = useNavigate();
  const [uploadStatus, setUploadStatus] = React.useState("disabled");
  const [isUploadDisabled, setIsUploadDisabled] = React.useState(true);
  const [showSuccess, setShowSuccess] = React.useState(false);
  const [showUploads, setShowUploads] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [showAlertModal, setShowAlertModal] = React.useState(false);
  const [showZipModal, setShowZipModal] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [files, setFiles] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [result, setResult] = React.useState([]);
  const [percent, setPercent] = useState([]);
  const [removable, setRemovable] = useState(true);
  const [password, setPassword] = useState("");
  const [isLargeZipFile, setIsLargeZipFile] = useState(false);
  const [baseURL, setBaseURL] = useState("");

  React.useEffect(() => {
    
    if (rowData?.area === AMERICAS) {
      setBaseURL(process.env.REACT_APP_API_URL_US)
    } else if (rowData?.area === EMEIA) {
      setBaseURL(process.env.REACT_APP_API_URL_EU)
    } else if (rowData?.area === APAC) {
      setBaseURL(process.env.REACT_APP_API_URL_AU)
    }


  }, [rowData?.area])


  const handlePrimaryClick = () => {
    setShowModal(true);
  };
  const hanldeSecondaryClick = () => {
    navigate('/uploadedFiles');

  }

  const generateGUID = () => {
    const guid = uuidv4();
    return guid;
  };


  // Wrappers around the two upload paths so the inactivity timeout is held open
  // for the whole transfer. `isUploadDisabled` and `isLoading` are not usable as
  // the signal here: both are also toggled for validation, and the `isLoading`
  // calls that would have bracketed the chunk loop are commented out.
  const uploadFilesInBatches = async (files) => {
    const endLongRunningTask = beginLongRunningTask("partner-batch-upload");
    try {
      return await runUploadFilesInBatches(files);
    } finally {
      endLongRunningTask();
    }
  };

  const runUploadFilesInBatches = async (files) => {
    // setIsLoading(true);
    setIsUploadDisabled(true);
    const transactionID = generateGUID(); // Generate a single transaction ID for all chunks

    const data = []
    files.map((file) => {
      const formData = new FormData();
      formData.append("ModifiedBy", "Test");
      formData.append("SubSector", rowData.subSector);
      formData.append("SubSubSector", rowData.subSubSector);
      formData.append("Region", rowData?.area);
      formData.append("EngagementId", rowData.engagementId);
      formData.append("UserID", 12);
      formData.append("Sector", rowData.sector);
      formData.append("UserEmailID", getAccount()?.username);
      formData.append("CCS", rowData.ccs);
      formData.append("Country", rowData.country);
      formData.append("projectName", rowData.projectName);
      formData.append("clientName", rowData.clientName);
      formData.append("sectorId", rowData.sectorId);
      formData.append("subSectorId", rowData.subSectorId);
      formData.append("subSubSectorId", rowData.subSubSectorId);
      formData.append("Function", "");
      formData.append("Config_file", "config");
      formData.append("Revenue", rowData.marketSize);
      formData.append("SSLCompetancy", rowData.sslCompetancy);
      formData.append("CreatedBy", getAccount()?.name);
      formData.append("Files", file);
      formData.append("NewRegion", rowData?.region);
      formData.append("Area", rowData.area);
      formData.append('TransactionID', transactionID);
      formData.append("Exsists", true);
      formData.append("eng_password", password);
      data.push({ formData, fileName: file.name });  // Store the file name for later reference
    })
    const postRequests = data.map(({ formData, fileName }) => {
      return apiQueryToUploadDataRegional.post(`${baseURL}/api/partners/add`, formData, {
        onUploadProgress: (progressEvent) => {
          let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          if (percentCompleted === 100) {
            percentCompleted = Math.floor(Math.random() * (10) + 90);
          }
          setPercent(prevPercent => {
            const newPercent = [...prevPercent];
            const fileIndex = newPercent.findIndex(p => p.fileName === fileName);
            if (fileIndex !== -1) {
              newPercent[fileIndex].percentage = percentCompleted;
            } else {
              newPercent.push({
                fileName: fileName,
                percentage: percentCompleted
              });
            }
            return newPercent;
          });
        }
      }).then(response => {
        // Once the API response is received, set the percentage to 100%
        setPercent(prevPercent => {
          const newPercent = [...prevPercent];
          const fileIndex = newPercent.findIndex(p => p.fileName === fileName);
          if (fileIndex !== -1) {
            newPercent[fileIndex].percentage = 100;
          }
          return newPercent;
        });
        return {
          status: "Success",
          fileName: fileName,
          response: response.data
        };
      }).catch(error => {
        // Handle the error case if needed
        return {
          status: "Error",
          fileName: fileName,
          error: error
        };
      });
    });

    const responses = await Promise.all(postRequests);
    // Now 'responses' is an array of objects with status, fileName, and either response or error

    setResult(responses); // Set the result state with the array of responses
    // setIsLoading(false);
    setUploadStatus("completed");
    setShowSuccess(true);
    setShowModal(true);
    setIsUploadDisabled(false);
  };
  const uploadZipFileInChunks = async () => {
    const endLongRunningTask = beginLongRunningTask("partner-zip-chunk-upload");
    try {
      return await runUploadZipFileInChunks();
    } finally {
      endLongRunningTask();
    }
  };

  const runUploadZipFileInChunks = async () => {
    const transactionID = generateGUID(); // Generate a single transaction ID for all chunks
    const chunkSize = 5 * 1024 * 1024; // 5MB
    const totalChunks = Math.ceil(files[0].size / chunkSize);
    let chunkPercentages = new Array(totalChunks).fill(0); // Initialize progress for each chunk
    const fileName = files[0].name;
    const newFileName = fileName.replace(/\.zip$/, '') + '-' + transactionID + '.zip';
    setIsUploadDisabled(true);

    const uploadChunk = async (chunk, index) => {
      let region = '';
      if (rowData?.country === UNITED_KINGDOM) {
        region = 'EMEIA-UK'
      } else {
        region = rowData?.area
      }
      const formData = new FormData();
      // Append other form data as needed
      formData.append("Region", region);
      formData.append("UserEmailID", getAccount()?.username);
      formData.append('Chunk', chunk);
      formData.append('chunkIndex', index);
      formData.append('totalChunks', totalChunks);
      formData.append('FileName', newFileName);
      formData.append('TransactionID', transactionID);

      return apiQueryToUploadDataRegional.post(`${baseURL}/api/partners/Uploading`, formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          chunkPercentages[index] = percentCompleted;
          const totalPercentCompleted = chunkPercentages.reduce((acc, curr) => acc + curr, 0) / totalChunks;
          let totalPercentCompletedRounded = parseFloat(totalPercentCompleted.toFixed(0)); // Round to two decimal places
          if (totalPercentCompletedRounded === 100) {
            totalPercentCompletedRounded = Math.floor(Math.random() * (10) + 90);
          }
          // Update the overall progress in the percent state
          setPercent(prevPercent => {
            const fileIndex = prevPercent.findIndex(p => p.fileName === fileName);
            if (fileIndex !== -1) {
              const newPercent = [...prevPercent];
              newPercent[fileIndex] = {
                fileName: fileName,
                percentage: totalPercentCompletedRounded
              };
              return newPercent;
            } else {
              return [...prevPercent, { fileName: fileName, percentage: totalPercentCompletedRounded }];
            }
          });
        }
      });
    };

    // Create an array of promises for all chunks except the last one
    const promises = [];
    for (let i = 0; i < totalChunks - 1; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, files[0].size);
      const chunk = files[0].slice(start, end);
      promises.push(uploadChunk(chunk, i));
    }

    // Upload all chunks except the last one
    try {
      await Promise.all(promises);
      // After all chunks except the last one have been uploaded, upload the last chunk
      const lastChunkIndex = totalChunks - 1;
      const start = lastChunkIndex * chunkSize;
      const end = files[0].size;
      const lastChunk = files[0].slice(start, end);
      await uploadChunk(lastChunk, lastChunkIndex);
      // All chunks have been uploaded successfully
      confirmZipUpload(transactionID, newFileName, fileName);


    } catch (error) {
      logger.error(`Error uploading chunks`, error);
      setResult([{ isSuccess: false }]);
      setShowSuccess(true);
      setShowModal(true);
    }
  };

  const onConfirmClick = () => {
    setRemovable(false);
    if (isLargeZipFile) {
      // If it's a large ZIP file, use the chunked upload logic
      uploadZipFileInChunks(files);
    } else {
      // Otherwise, use the normal batch upload logic
      uploadFilesInBatches(files);
    }
    setShowModal(false);
    setPassword("");
  };

  const onZipModalClose = (event, reason) => {
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setShowZipModal(false);
      setShowModal(true);
    }
  };

  const getSameFiles = (array1, array2, key) => {
    return array1.filter(item1 => array2.some(item2 => item1[key] === item2[key]));
  }

  const removeCommonFiles = (array1, array2, key) => {
    return [
      ...array1.filter(obj1 => !array2.some(obj2 => obj1[key] === obj2[key]))
    ];
  }

  const onDrop = (selectedFiles) => {

    let foundInvalidFile = false;
    const listFilesInZip = (zip, pathPrefix = "") => {
      setIsLoading(true);// Flag to indicate if an invalid file was found

      Object.keys(zip.files).forEach((filename) => {
        if (foundInvalidFile) return;

        const file = zip.files[filename];
        if (!file.dir) {
          const extension = filename.substr(filename.lastIndexOf(".") + 1).toLowerCase();

          if (['pdf', 'csv', 'pptx', 'doc', 'docx', 'xlsx', 'xlsb', 'ppt', 'xlsm', 'zip', 'pbix', 'pbi', 'txt'].includes(extension)) {
            file["error"] = false;
          } else {
            file["error"] = true;
            foundInvalidFile = true;
            return;
          }

          if (!file["error"]) {
            logger.info(pathPrefix + filename);
          }

          if (extension === "zip" && !file["error"]) {
            zip
              .file(filename)
              .async("arraybuffer")
              .then((content) => {
                JSZip.loadAsync(content).then((nestedZip) => {
                  listFilesInZip(nestedZip, pathPrefix + filename + "/");
                });
              });
          }
        }
      });

      setIsLoading(false);

      if (foundInvalidFile) {
        setShowAlertModal(true);
        setAlertMessage("Please try uploading again as one or more files are not supported.");
        setFiles([]);
      }
    };

    // Process each selected file
    selectedFiles.forEach((file) => {
      if (file.path.endsWith(".zip")) {
        const reader = new FileReader();
        reader.onload = function (event) {
          const data = event.target.result;
          JSZip.loadAsync(data).then((zip) => {
            listFilesInZip(zip); // Start the recursive listing with the top-level zip
          });
        };
        reader.readAsArrayBuffer(file);
      }
    });
    const matchingFiles = getSameFiles(selectedFiles, files, 'name');
    const newFiles = removeCommonFiles(selectedFiles, matchingFiles, 'name');
    const totalSize = files.reduce((acc, file) => acc + file.size, 0) + newFiles.reduce((acc, file) => acc + file.size, 0);

    newFiles.forEach((file) => {
      const extension = file?.path.substr(file?.path.lastIndexOf(".") + 1).toLowerCase();
      if (['pdf', 'csv', 'pptx', 'doc', 'docx', 'xlsx', 'xlsb', 'ppt', 'xlsm', 'zip', 'txt'].includes(extension)) {
        file["error"] = false;
      } else {
        file["error"] = true;
      }
      // Check if the file is a ZIP and larger than 2 GB
      if (file.path.endsWith('.zip') && file.size > 50 * 1024 * 1024 * 1024) { // 2 GB in bytes
        file["error"] = true;
        file["errorMessage"] = "Uploads exceeding 50GB cannot be processed. Please divide your upload into smaller segments before uploading.";
      }
    });

    const invalidFiles = newFiles.some(file => file.error === true);
    if (invalidFiles) {
      // Find the first file with an error message and use it for the alert
      const firstInvalidFile = newFiles.find(file => file.error === true);
      const errorMessage = firstInvalidFile.errorMessage || `Please try uploading again as one or more files are not supported.`;
      setShowAlertModal(true);
      setAlertMessage(errorMessage);
    } else {
      // Check if there is a mix of ZIP and non-ZIP files among the new files
      const zipFiles = newFiles.filter(file => file.path.endsWith('.zip'));
      const nonZipFiles = newFiles.filter(file => !file.path.endsWith('.zip'));

      // Check if there is a mix of ZIP and non-ZIP files between the new files and existing files
      const existingZipFiles = files.filter(file => file.path.endsWith('.zip'));
      const existingNonZipFiles = files.filter(file => !file.path.endsWith('.zip'));

      if ((zipFiles.length > 0 && nonZipFiles.length > 0) ||
        (zipFiles.length > 0 && existingNonZipFiles.length > 0) ||
        (nonZipFiles.length > 0 && existingZipFiles.length > 0)) {
        // Alert the user that they cannot upload ZIP and non-ZIP files together
        setShowAlertModal(true);
        setAlertMessage("Upload ZIP and non-ZIP files separately, simultaneous uploads of both types are not supported.");
      } else if (zipFiles.length > 1 || (zipFiles.length > 0 && existingZipFiles.length > 0)) {
        // Alert the user that they cannot upload more than one ZIP file at a time
        setShowAlertModal(true);
        setAlertMessage("Please try uploading a single ZIP file at a time.");
      } else if (totalSize <= 750 * 1024 * 1024 && zipFiles.length === 0 && (existingNonZipFiles.length + nonZipFiles.length) <= 75) { // 750 MB in bytes
        setFiles([...files, ...newFiles]);
        setShowUploads(true);
        setIsUploadDisabled(false);
        setIsLargeZipFile(false);
        setShowAlertModal(true);
        setAlertMessage('Files are ready for upload. Click "Upload" to proceed.');

      } else if (zipFiles.length === 1 && existingZipFiles.length === 0 && existingNonZipFiles.length === 0) {
        // The file is a ZIP and it's the only file, proceed with the upload
        setFiles([...files, ...newFiles]);
        setShowUploads(true);
        setIsUploadDisabled(false);
        setIsLargeZipFile(true);
        setShowAlertModal(true);
        setAlertMessage('Files are ready for upload. Click "Upload" to proceed.');
      } else {
        // The total size exceeds the limit and it's not a single ZIP file
        setShowAlertModal(true);
        setAlertMessage("Maximum file size exceeded. Upload up to 750MB or use a ZIP for larger files.");
      }
    }

  };

  const onModalClose = (event, reason) => {
    setPassword("");
    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
      setShowModal(false);
    }
    resetFiles();
  };

  const onAlertModalClose = () => {
    setShowAlertModal(false);
  };

  const confirmZipUpload = (transactionId, newFileName, fileName) => {
    setIsLoading(true);
    let regionX = '';
    if (rowData?.country === UNITED_KINGDOM) {
      regionX = 'EMEIA-UK'
    } else {
      regionX = rowData?.area
    }
    const formData = new FormData();
    formData.append("ModifiedBy", "Test");
    formData.append("SubSector", rowData?.subSector);
    formData.append("SubSubSector", rowData?.subSubSector);
    formData.append("EngagementId", rowData?.engagementId)
    formData.append("UserID", 12);
    formData.append("Sector", rowData?.sector);
    formData.append("CCS", rowData?.ccs);
    formData.append("Country", rowData?.country);
    formData.append("projectName", rowData?.projectName);
    formData.append("clientName", rowData?.clientName);
    formData.append("sectorId", rowData?.sectorId);
    formData.append("subSectorId", rowData?.subSectorId);
    formData.append("subSubSectorId", rowData?.subSubSectorId);
    formData.append("Function", "Default");
    formData.append("Config_file", "config");
    formData.append("Revenue", rowData?.marketSize);
    formData.append("SSLCompetancy", rowData?.sslCompetancy);
    formData.append("CreatedBy", getAccount()?.name);
    formData.append("FileName", newFileName);
    formData.append("TransactionID", transactionId);
    formData.append("Region", regionX);
    formData.append("NewRegion", rowData?.region);
    formData.append("Area", rowData?.area);
    formData.append("UserEmailID", getAccount()?.username);
    formData.append("Exsists", true);
    formData.append("eng_password", password);
    apiQueryToUploadDataRegional
      .post(
        `${baseURL}/api/partners/ConfirmZipUpload`,
        formData
      )
      .then((response) => {
        setResult([response.data])
        setPercent([{ fileName: fileName, percentage: 100 }]);

        logger.info("File uploaded successfully", response.data);
        setShowSuccess(true);
        setShowModal(true);
        setIsLoading(false);
        setUploadStatus("completed");
        setIsUploadDisabled(false);

      })
      .catch((error) => {

        if (error.response && error.response.status === 500) {
          if (error.response.data.statusCode && error.response.data.statusCode === 406) {
            setShowZipModal(true);
            // setShowModal(true);
            setIsLoading(false);
            setAlertMessage("The password provided is invalid for the ZIP file. Please try uploading it again with the correct password.");
          }
        } else {
          setShowModal(true);
          logger.error("Error uploading file", error);
          setResult([{ isSuccess: false }])
          setShowSuccess(true);
          setIsLoading(false);
          //  setShowModal(true);
          setUploadStatus("failed");
          setIsUploadDisabled(false);

        }
      });
  }

  const resetFiles = () => {
    setShowModal(false);
    setFiles([]);
    setPassword("");
    setIsUploadDisabled(true);
    setShowSuccess(false);
    setResult([]);
    setPercent([]);
  }

  const onOKClick = () => {
    setShowModal(false);
    navigate('/uploadedFiles')
    setPassword("");
  }

  return (
    <section>
      <div className="uploadPartnerData-container">
        <div className="head-wrapper">
          <MotifLabel className="heading">Upload Data</MotifLabel>
          <div className="button-wrapper">
            <MotifButton
              onClick={hanldeSecondaryClick}
              size="small"
              variant="primary"
            >
              {"View All Engagements"}
            </MotifButton>
            <MotifButton
              onClick={handlePrimaryClick}
              size="small"
              disabled={isUploadDisabled}
              variant="primary"
            >
              Upload
            </MotifButton>
          </div>
        </div>
        <div className="wrapper">
          <div className="progress">
            <MotifProgressIndicator variant="row">
              <MotifProgressIndicatorStep
                heading="Enter Details"
                status={'completed'}
              />
              <MotifProgressIndicatorStep
                heading="Upload Data"
                status={uploadStatus}
                className="second"
              />
            </MotifProgressIndicator>
          </div>
          {(
            <div className="second-step-upload">
              <MotifLabel className="form-heading">
                Choose files to upload
              </MotifLabel>
              <div className="file-upload">
                <MotifFormField>
                  <MotifFileUploader
                    id="my-id"
                    label="Click to upload or drag and drop"
                    onDrop={onDrop}
                    reactive
                    disabled={percent.length > 0}
                  ></MotifFileUploader>

                </MotifFormField>
              </div>
              <div className="info-msg-wrapper">
                <div className="info-msg">• You can upload 75 files up to 750MB or one ZIP file up to 2GB.</div>
                <div className="info-msg">• Allowed file types: PDF, DOC, DOCX, XLSX, XLSB, XLSM, CSV, PPTX, PPT.</div>
                <div className="info-msg">• Allowed file types within ZIP : PDF, DOC, DOCX, XLSX, XLSB, XLSM, CSV, PPTX, PPT, TXT, PBIX.</div>
                <div className="info-msg">• The platform does not support direct folder uploads. Please compress the folder into a ZIP file prior to uploading.</div>
              </div>
              {showUploads &&
                files.map((file, index) => {
                  const fileProgress = percent.find(p => p?.fileName === file?.name) || { percentage: 0 };
                  return (
                    <MotifFileUploaderItem
                      key={file.path + index}
                      aria-label="Item aria-label text"
                      fileName={
                        <div className="fileNameContainer">{file.path}</div>
                      }
                      fileSize={file.size}
                      removable={removable}
                      // removable
                      error={file.error}
                      percentUploaded={fileProgress.percentage}
                      showProgress={true}
                      icons={<MotifIcon src={checkIcon} />}
                      fileIcon={fileProgress.percentage == 100 ? <MotifIcon src={checkIcon} /> :
                        <MotifIcon src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTQgMkg2Yy0xLjEgMC0xLjk5LjktMS45OSAyTDQgMjBjMCAxLjEuODkgMiAxLjk5IDJIMThjMS4xIDAgMi0uOSAyLTJWOGwtNi02em0yIDE2SDh2LTJoOHYyem0wLTRIOHYtMmg4djJ6bS0zLTVWMy41TDE4LjUgOUgxM3oiLz48L3N2Zz4=" />
                      }
                      onRemove={() => {
                        const newFiles = files.filter(item => item.path !== file.path);
                        setFiles(newFiles);
                        if ((newFiles.length === 0)) {
                          setIsUploadDisabled(true)
                        }
                      }}
                    />
                  );
                })
              }
              <Dialog
                onClose={onModalClose}
                open={showModal}
                className="custom-dialog"
                disableEscapeKeyDown
              >
                <DialogTitle>{showSuccess ? 'Add more files or Click OK to proceed' : 'Confirm'}</DialogTitle>

                {
                  !showSuccess && (
                    <IconButton
                      onClick={onModalClose}
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  )
                }

                <DialogContent dividers className="modal-content">
                  {showSuccess && isLargeZipFile ? (
                    result?.map((x, index) => {

                      return x.isSuccess ? (
                        <MotifToast key={index} variant="success"> {/* Add a unique key */}
                          <div className="result">
                            {`Zip file uploaded successfully`}
                          </div>
                        </MotifToast>
                      ) : (
                        <MotifToast key={index} variant="error"> {/* Add a unique key */}
                          <div className="result">
                            {`Something went wrong. Please try again`}
                          </div>
                        </MotifToast>
                      );
                    })
                  ) : (
                    result?.map((x, index) => { // Assuming 'result' is an array and not nested under 'result.result'
                      return x.status === "Success" ? (
                        <MotifToast key={index} variant="success"> {/* Add a unique key */}
                          <div className="result">
                            {`${x.fileName ? x.fileName : ''} uploaded successfully`}
                          </div>
                        </MotifToast>
                      ) : (
                        <MotifToast key={index} variant="error"> {/* Add a unique key */}
                          <div className="result">
                            {`${x.fileName ? x.fileName : ''} upload failed. Please try again`}
                          </div>
                        </MotifToast>
                      );
                    })
                  )}
                  {
                    isLoading &&
                    <MotifProgressLoader show variant="default" />
                  }
                  {
                    !showSuccess && <>
                      {<span>Please confirm the data upload</span>}
                      <p>
                        Important: Only one password can be used for each upload, if applicable; otherwise, please leave it blank.
                      </p>
                      <p>
                        If your files have different passwords, upload them in batches. </p>
                      <p>
                        Once you click 'Confirm,' your files will be uploaded to the regional DBS storage for processing by DBS. </p>
                      <p>
                        Please note that the password is not being checked on non-ZIP files until processing. </p>

                      <MotifFormField
                        aria-label="Password"
                        role="group"
                      >
                        <MotifLabel
                          aria-label="Password"
                          for="input"
                        >
                          Enter password
                        </MotifLabel>
                        <MotifInput
                          aria-label="Password"
                          ariaLabel="Password"
                          id="input"
                          label="Password"
                          type="password"
                          onChange={(event) => setPassword(event.target.value)}
                          value={password}

                        />
                        <span className="pwd-msg">Your password is encrypted and stored temporarily and will be deleted after processing the files.</span>

                      </MotifFormField>

                    </>
                  }
                </DialogContent>
                <DialogActions>
                  {
                    showSuccess && (
                      <MotifButton
                        onClick={resetFiles}
                        size="medium"
                        type="button"
                        variant="primary"
                        disabled={isLoading}
                      >

                        Add more files
                      </MotifButton>
                    )
                  }
                  <MotifButton
                    onClick={showSuccess ? onOKClick : resetFiles}
                    size="medium"
                    type="button"
                    variant="secondary"
                    disabled={isLoading}
                  >
                    {
                      showSuccess ? 'OK' : 'Cancel'
                    }
                  </MotifButton>
                  {
                    !showSuccess && <MotifButton
                      onClick={onConfirmClick}
                      size="medium"
                      disabled={isLoading}
                      type="button"
                    >
                      Confirm
                    </MotifButton>
                  }

                </DialogActions>
              </Dialog>
              <Dialog
                onClose={onAlertModalClose}
                open={showAlertModal}
                className="alert-dialog"
              >
                <DialogTitle>
                  <IconButton
                    onClick={onAlertModalClose}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <div className="heading">Note</div>
                </DialogTitle>
                <DialogContent dividers className="modal-content">
                  <p>{alertMessage}</p>
                </DialogContent>
                <DialogActions>
                  <MotifButton
                    onClick={onAlertModalClose}
                    color="primary"
                    variant="contained"
                  >
                    OK
                  </MotifButton>
                </DialogActions>
              </Dialog>
              <Dialog
                onClose={onZipModalClose}
                open={showZipModal}
                className="alert-dialog"
              >
                <DialogTitle>
                  <IconButton
                    onClick={() => onZipModalClose(null, 'buttonClick')}
                    sx={{
                      position: "absolute",
                      right: 8,
                      top: 8,
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <div className="heading">Note</div>
                </DialogTitle>
                <DialogContent dividers className="modal-content">
                  <p>{alertMessage}</p>
                </DialogContent>
                <DialogActions>
                  <MotifButton
                    onClick={onZipModalClose}
                    color="primary"
                    variant="contained"
                  >
                    OK
                  </MotifButton>
                </DialogActions>
              </Dialog>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};
